import React, { useState, useContext, useRef } from 'react';
import {
    CourseCardsContainer, CourseCard, CourseCategory, CourseTitle, CoursePlayButton, CourseCardBackground, CourseTitleAndPlay, CourseInfoSeparator
} from './CourseCardsStyle';
import { getCourseCardDetails, getCategoryListMap } from '../../helpers/courseCardHelper';
import { APP_CONSTANTS, defaultBgImgId } from '../../constants';
import { SetupContext } from 'src/consumer/context/SetupContext';
import { PlayerContext } from 'src/consumer/context/PlayerContext';
import { resetPlayerData } from '../../helpers/playerHelper';
import { HorizontalScrollLeftButton, HorizontalScrollRightButton } from '../CardList/CardListStyle';
import { useEffect } from 'react';

export const renderCardsList = (props, setupData, setPlayerData, playerData) => {

    const { cardsData, tilePolicyId } = props;

    return cardsData.map((card, index) => {
        const { courseTitle, courseIconImage, courseCategory, courseDescription, coverIconColor } = getCourseCardDetails(card, getCategoryListMap(setupData));
        return (
            <CourseCard onClick={() => {
                setPlayerData({
                    ...resetPlayerData(playerData),
                    showPlayer: true,
                    selectedCard: playerData.showPIP ? playerData?.selectedCard : card,
                    source: 'tile',
                    id: tilePolicyId
                })
            }} key={index}>
                <CourseCardBackground imgURL={APP_CONSTANTS.MEDIA_URL + (courseIconImage || defaultBgImgId)}>

                    <CourseTitleAndPlay>
                        {courseCategory && <CourseCategory>
                            {courseCategory}
                        </CourseCategory>}
                        <CourseInfoSeparator />
                        <CourseTitle>
                            {courseTitle}
                        </CourseTitle>
                        <CoursePlayButton>Play</CoursePlayButton>
                    </CourseTitleAndPlay>

                </CourseCardBackground>
            </CourseCard>
        )
    })
}

const CourseCards = (props) => {

    const { playerData, setPlayerData } = useContext(PlayerContext);
    const { setupData } = useContext(SetupContext);

    const { areTileItemsHovered } = props;
    const cardRef = useRef();
    const [leftButtonVisible, setLeftButtonVisible] = useState(false);
    const [rightButtonVisible, setRightButtonVisible] = useState(false);
    const handleScrollLeft = () => {
        if (cardRef?.current) {
            const containerWidth = cardRef?.current?.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft -= scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScrollRight = () => {
        if (cardRef?.current) {
            const containerWidth = cardRef?.current?.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft += scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScroll = (event) => {
        const container = event?.target;
        const scrollPosition = container?.scrollLeft;
        const maxScrollLeft = container?.scrollWidth - container?.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }
    useEffect(() => {
        const container = cardRef?.current;
        const scrollPosition = container?.scrollLeft;
        const maxScrollLeft = container?.scrollWidth - container?.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }, []);


    return (
        <>
            <CourseCardsContainer ref={cardRef} onScroll={handleScroll}>

                {areTileItemsHovered && leftButtonVisible &&
                    <HorizontalScrollLeftButton onClickFunction={handleScrollLeft} />
                }

                {renderCardsList(props, setupData, setPlayerData, playerData)}

                {areTileItemsHovered && rightButtonVisible &&
                    <HorizontalScrollRightButton onClickFunction={handleScrollRight} />
                }

            </CourseCardsContainer>
        </>
    )
}

export default CourseCards;
